import React from "react";
import { Modal, Row, Col } from "antd";

const RowForm = props => (
  <Row style={{ padding: " 5px 10px" }}>{props.children}</Row>
);

class ModalBusinessAreaDetail extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <Modal
        title="Business Area Detail"
        visible={this.props.visible}
        onOk={() => this.props.visibleModal()}
        onCancel={() => this.props.visibleModal()}
        width={700}>
        <p>Business Area Detail</p>

        <RowForm>
          <Col span={8}>Area Name</Col>
          <Col span={16}>: {data ? data.area : null}</Col>
        </RowForm>
        <RowForm>
          <Col span={8}>Director Name</Col>
          <Col span={16}>
            :{" "}
            {data
              ? data.Director
                ? data.Director.User
                  ? data.Director.User.name
                  : ""
                : ""
              : null}
          </Col>
        </RowForm>
      </Modal>
    );
  }
}

export default ModalBusinessAreaDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Area/BusinessArea/ModalBusinessAreaDetail.js